var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('connection-fail',{attrs:{"active":_vm.failConnect},on:{"update:active":function($event){_vm.failConnect=$event}}}),_c('loading',{ref:"loading"}),_c('toast-error',{ref:"toastError"}),_c('toast-notification',{ref:"toastAction",staticStyle:{"right":"10px","top":"70px"},attrs:{"type-message":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }